var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-table',{attrs:{"url":"/api/v1/customerProfile","filter":[
      {
        name: 'AffiliateRevenue',
        value: _vm.id
      },
      {
        name: 'sort',
        mode: 'DESC',
        attribute: 'revenue'
      }
    ],"attributes":[
      {
        attribute: 'name',
        name: 'Name',
        type: 'ProfileCell'
      },
      {
        attribute: 'revenue',
        name: 'Umsatz',
        type: 'CurrencyCell'
      },
      {
        attribute: 'latest',
        name: 'Letzter Kauf',
        type: 'DateTimeCell'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }